import { render, staticRenderFns } from "./LinkedinChannels.vue?vue&type=template&id=bc1639e8&scoped=true"
import script from "./LinkedinChannels.vue?vue&type=script&lang=js"
export * from "./LinkedinChannels.vue?vue&type=script&lang=js"
import style0 from "./LinkedinChannels.vue?vue&type=style&index=0&id=bc1639e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1639e8",
  null
  
)

export default component.exports